import React, { useState } from 'react'

import Switch from '../../form/Switch'
import useDisableRequest from './_request/disableEntityRequest'

const SwitchDisabled = ({ initialValue, client, entity, onSuccess, record, ...props }) => {
  const [value, setValue] = useState(record.enabled)
  const [handleChange] = useDisableRequest({ client, entity, value, record, callback: setValue })

  return (
    <Switch
      onChange={() => {
        setValue(!value)
        handleChange()
      }}
      value={value}
      {...props}
    />
  )
}

export default SwitchDisabled
